import { render } from "./SplitDialog.vue?vue&type=template&id=94ae28d6"
import script from "./SplitDialog.vue?vue&type=script&lang=js"
export * from "./SplitDialog.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__